<template>
  <div class="mt-5" id="map-loader">
    <span class="title is-6 tag is-primary num-info"
      ><router-link to="/restaurants"
        ><i class="fas fa-store fa-lg"></i></router-link
    ></span>
    <p class="title is-6 tag is-primary num-info">
      Number of favorite restaurants: {{ this.restaurants.length }}
    </p>
    <input
      class="input is-info is-rounded m-2"
      type="text"
      ref="searchBox"
      placeholder="Find a Restaurant"
    />
    <button class="button m-2 is-info" ref="locationBtn">
      <i class="fas fa-location-arrow"></i>
    </button>
    <button class="button m-2 is-info" ref="nearbyBtn">
      <i class="fas fa-search-location"></i>
    </button>
    <div class="google-map" ref="googleMap"></div>
  </div>
</template>

<script>
import InfoWindowComponent from "./InfoWindow";
import Vue from "vue";
import { db, auth } from "@/firebaseConfig";
import firebase from "firebase/app";

export default {
  name: "GoogleMapsLoader",
  props: {
    mapConfig: Object,
    id: String,
  },
  data() {
    return {
      google: null,
      map: null,
      searchBox: null,
      restaurants: [],
      restaurant: null,
      infowindowOpen: false,
    };
  },
  firestore: function () {
    return {
      restaurant: db.collection("restaurants").doc(this.id),
      restaurants: db
        .collection("restaurants")
        .where("userId", "==", auth.currentUser.uid),
    };
  },
  mounted() {
    this.createMap();
  },
  beforeUpdate: function () {
    if (!this.restaurants) return;
    this.addRestaurantMarkers();
    this.showLocation(this.restaurant);
  },
  methods: {
    handleLocationError(browserHasGeolocation, infoWindow, pos) {
      infoWindow.setPosition(pos);
      infoWindow.setContent(
        browserHasGeolocation
          ? "Error: The Geolocation service failed."
          : "Error: Your browser doesn't support geolocation."
      );
      if (this.infowindowOpen) {
        this.infowindowOpen.close();
      }

      this.infowindowOpen = infoWindow;
      infoWindow.open(this.map);
    },
    createMap() {
      const mapContainer = this.$refs.googleMap;
      this.map = new window.google.maps.Map(mapContainer, this.mapConfig);

      const searchInput = this.$refs.searchBox;
      this.searchBox = new window.google.maps.places.SearchBox(searchInput);
      this.map.controls[window.google.maps.ControlPosition.LEFT_TOP].push(
        searchInput
      );
      this.map.addListener("bounds_changed", () => {
        this.searchBox.setBounds(this.map.getBounds());
      });

      let markers = [];
      // Listen for the event fired when the user selects a prediction and retrieve
      // more details for that place.
      this.searchBox.addListener("places_changed", () => {
        const places = this.searchBox.getPlaces();

        if (places.length == 0) {
          return;
        }
        // Clear out the old markers.
        markers.forEach((marker) => {
          marker.setMap(null);
        });
        markers = [];
        // For each place, get the icon, name and location.
        const bounds = new window.google.maps.LatLngBounds();
        places.forEach((place) => {
          if (!place.geometry || !place.geometry.location) {
            console.log("Returned place contains no geometry");
            return;
          }
          var existed = false;
          var restaurantId = null;
          this.restaurants.forEach((restaurant) => {
            if (
              restaurant.location._lat == place.geometry.location.lat() &&
              restaurant.location._long == place.geometry.location.lng()
            ) {
              existed = true;
              restaurantId = restaurant.id;
              return;
            }
          });
          var props = {};
          if (existed) {
            props = {
              title: place.name,
              location: new firebase.firestore.GeoPoint(
                place.geometry.location.lat(),
                place.geometry.location.lng()
              ),
              address: place.formatted_address,
              added: existed,
              restId: restaurantId,
            };
          } else {
            props = {
              title: place.name,
              location: new firebase.firestore.GeoPoint(
                place.geometry.location.lat(),
                place.geometry.location.lng()
              ),
              address: place.formatted_address,
              added: existed,
            };
          }

          var InfoWindow = Vue.extend(InfoWindowComponent);
          var instance = new InfoWindow({
            propsData: props,
          });
          instance.$mount();
          var newInfoWindow = new window.google.maps.InfoWindow({
            content: instance.$el,
          });

          // Create a marker for each place.
          var marker = new window.google.maps.Marker({
            map: this.map,
            title: place.name,
            position: place.geometry.location,
          });
          markers.push(marker);
          if (this.infowindowOpen) {
            this.infowindowOpen.close();
          }

          this.infowindowOpen = newInfoWindow;
          newInfoWindow.open(this.map, marker);
          marker.addListener("click", () => {
            if (this.infowindowOpen) {
              this.infowindowOpen.close();
            }

            this.infowindowOpen = newInfoWindow;
            newInfoWindow.open(this.map, marker);
          });
          if (place.geometry.viewport) {
            // Only geocodes have viewport.
            bounds.union(place.geometry.viewport);
          } else {
            bounds.extend(place.geometry.location);
          }
        });
        this.map.fitBounds(bounds);
        this.$refs.searchBox.value = "";
      });
      let infoWindow;
      infoWindow = new window.google.maps.InfoWindow();
      const locationButton = this.$refs.locationBtn;
      this.map.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(
        locationButton
      );
      locationButton.addEventListener("click", () => {
        // Try HTML5 geolocation.
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              };
              infoWindow.setPosition(pos);
              this.map.setZoom(17);
              infoWindow.setContent("Location found.");
              if (this.infowindowOpen) {
                this.infowindowOpen.close();
              }

              this.infowindowOpen = infoWindow;
              infoWindow.open(this.map);
              this.map.setCenter(pos);
            },
            () => {
              this.handleLocationError(true, infoWindow, this.map.getCenter());
            }
          );
        } else {
          // Browser doesn't support Geolocation
          this.handleLocationError(false, infoWindow, this.map.getCenter());
        }
      });

      //let infoWindow2;
      let service;
      var m = this.map;
      let pos;
      var restaurants= this.restaurants;
      // var recMarkers = [];

      const nearbyButton = this.$refs.nearbyBtn;
      this.map.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(
        nearbyButton
      );

      nearbyButton.addEventListener("click", () => {
        // Try HTML5 geolocation.
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              };
              var curLoc = new window.google.maps.LatLng(pos.lat, pos.lng);
              
              var request = {
                location: curLoc,
                radius: "100",
                query: "restaurant",
              };
              service = new window.google.maps.places.PlacesService(m);
              service.textSearch(request, callback);

              function createMarker(place) {
                // var m = this.map;
                if (!place.geometry || !place.geometry.location) return;



var existed = false;
          var restaurantId = null;
          restaurants.forEach((restaurant) => {
            if (
              restaurant.location._lat == place.geometry.location.lat() &&
              restaurant.location._long == place.geometry.location.lng()
            ) {
              existed = true;
              restaurantId = restaurant.id;
              return;
            }
          });
          var props = {};
          if (existed) {
            props = {
              title: place.name,
              location: new firebase.firestore.GeoPoint(
                place.geometry.location.lat(),
                place.geometry.location.lng()
              ),
              address: place.formatted_address,
              added: existed,
              restId: restaurantId,
            };
          } else {
            props = {
              title: place.name,
              location: new firebase.firestore.GeoPoint(
                place.geometry.location.lat(),
                place.geometry.location.lng()
              ),
              address: place.formatted_address,
              added: existed,
            };
          }






                var InfoWindow = Vue.extend(InfoWindowComponent);
                
                var instance = new InfoWindow({
                  propsData: props,
                });
                instance.$mount();
                var infoWindow2 = new window.google.maps.InfoWindow({
                  content: instance.$el,
                });
                const image =
                  "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png";
                const marker = new window.google.maps.Marker({
                  map: m,
                  position: place.geometry.location,
                  icon: image,
                });
                window.google.maps.event.addListener(marker, "click", () => {
                  infoWindow2.open(m);
                  infoWindow2.setPosition(place.geometry.location);
                });
              }
              function callback(results, status) {
                if (
                  status == window.google.maps.places.PlacesServiceStatus.OK
                ) {
                  for (var i = 0; i < results.length; i++) {
                    createMarker(results[i]);
                    // marker.setMap(this.map);
                  }
                }
              }

              //infoWindow2.setPosition(pos);
              this.map.setZoom(15);
              // infoWindow2.setContent("Recommending Nearby Restaurants.");
              // infoWindow2.open(this.map);
              this.map.setCenter(pos);
            },
            () => {
              this.handleLocationError(true, infoWindow, this.map.getCenter());
            }
          );
        } else {
          // Browser doesn't support Geolocation
          this.handleLocationError(false, infoWindow, this.map.getCenter());
        }
      });
    },

    addRestaurantMarkers() {
      const bounds = new window.google.maps.LatLngBounds();
      this.restaurants.forEach((restaurant) => {
        var InfoWindow = Vue.extend(InfoWindowComponent);
        var instance = new InfoWindow({
          propsData: {
            title: restaurant.name,
            location: restaurant.location,
            address: restaurant.address,
            added: true,
            restId: restaurant.id,
          },
        });
        instance.$mount();
        var newInfoWindow = new window.google.maps.InfoWindow({
          content: instance.$el,
        });

        // Create a marker for each place.
        var marker = new window.google.maps.Marker({
          map: this.map,
          title: restaurant.name,
          position: {
            lat: restaurant.location._lat,
            lng: restaurant.location._long,
          },
        });
        marker.addListener("click", () => {
          if (this.infowindowOpen) {
            this.infowindowOpen.close();
          }

          this.infowindowOpen = newInfoWindow;
          newInfoWindow.open(this.map, marker);
        });
        bounds.extend({
          lat: restaurant.location._lat,
          lng: restaurant.location._long,
        });
      });
      this.map.fitBounds(bounds);
    },
    showLocation(restaurant) {
      if (!restaurant) return;
      const bounds = new window.google.maps.LatLngBounds();
      bounds.extend({
        lat: restaurant.location._lat,
        lng: restaurant.location._long,
      });
      this.map.fitBounds(bounds);
      this.$unbind("restaurant");
    },
  },
};
</script>


<style>
#map-loader .google-map {
  height: 90vh;
}

#map-loader input {
  width: 95%;
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  #map-loader input {
    width: 40%;
  }
}

#map-loader .num-info {
  background: #caf0f8;
  color: black;
}
</style>
